<template>
  <div class="tw-flex tw-flex-col tw-gap-4 tw-pb-4 tw-px-6">
    <SfAssistantCheck
      v-for="checkId in validGeneralCheckIds"
      :key="checkId"
      :check="assistantChecks[checkId]"
      :read="checkReadStatus[checkId]"
      :read-by-users="checkReadByUsers[checkId]"
    />
    <template v-for="workflow in hierarchy" :key="workflow.id">
      <template v-for="context in workflow.children" :key="context.id">
        <SfAssistantChecksSectionPanel
          :workflow-id="workflow.id"
          :context-id="context.id"
        />
      </template>
    </template>
  </div>
</template>

<script setup lang="ts">
import { onMounted, computed } from 'vue'
import { storeToRefs } from 'pinia'

import SfAssistantChecksSectionPanel from './sf-assistant-checks-section-panel.vue'
import SfAssistantCheck from './sf-assistant-check.vue'

import { useSfAssistantChecksPage } from '../stores/page'
import { useAssistantChecksStore } from '@app/application/sf-assistant-checks/stores/assistant-checks'

const pageStore = useSfAssistantChecksPage()
const assistantChecksStore = useAssistantChecksStore()

onMounted(() => {
  assistantChecksStore.initFromPageStore()
})

const { checkReadStatus, checkReadByUsers, generalCheckIds, hierarchy } =
  storeToRefs(pageStore)
const { assistantChecks } = storeToRefs(assistantChecksStore)

const validGeneralCheckIds = computed(() =>
  generalCheckIds.value.filter((id) => assistantChecks.value[id])
)
</script>
